import { render } from "./NewCertificateDialog.vue?vue&type=template&id=13ac71be"
import script from "./NewCertificateDialog.vue?vue&type=script&lang=js"
export * from "./NewCertificateDialog.vue?vue&type=script&lang=js"

import "./NewCertificateDialog.vue?vue&type=style&index=0&id=13ac71be&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__